<template class="currency-text-component c-text-c">
  <span v-if="!isPromoDiscount" class="c-text-c__default">{{ formattedCurrency }}{{ appendText }}</span>
  <span v-else class="c-text-c__promo">-{{ formattedCurrency }}{{ appendText }}</span>
</template>

<script>
  import { mapGetters } from "vuex";
  import "intl";
  import "intl/locale-data/jsonp/en-US";

  export default {
    props: {
      amount: {
        type: Number,
        default: 0
      },
      currencyCode: {
        type: String,
        default: null
      },
      appendText: {
        type: String,
        default: ""
      },
      isPromoDiscount: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      intl: Object
    }),
    computed: {
      ...mapGetters(["billingCurrencyCode"]),
      currencyCodeToUse() {
        if (this.currencyCode != null) {
          return this.currencyCode;
        }
        return this.billingCurrencyCode;
      },
      formattedCurrency() {
        if (this.intl === Object) {
          return;
        }

        let currencyStr = new this.intl.NumberFormat("en-US", {
          style: "currency",
          currency: this.currencyCodeToUse
        }).format(this.amount);

        return formatNegativeNumbersWithParenthesis(currencyStr);
      }
    },
    mounted() {
      if (global.Intl !== undefined) {
        this.intl = Intl;
      } else {
        this.intl = require("intl");
      }
    }
  };

  function formatNegativeNumbersWithParenthesis(currencyStr) {
    return currencyStr.indexOf("-") === 0
      ? currencyStr.replace("-", "(") + ")"
      : currencyStr;
  }
</script>
<style lang="scss">
.c-text-c {
  white-space: nowrap;

  .c-text-c__default {
    white-space: nowrap;
  }

  .c-text-c__promo {
    white-space: nowrap;
    color: #c20100;
    font-size: 0.8em;
  }
} 
</style>


